import React from "react";

export const RightArrowIcon = ({ width, height, fill = "#000" }) => {
  return (
    <svg width={width||"27"} height={height||"17"} viewBox="0 0 27 17" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path d="M0.992188 9.36138H22.7028L17.2821 14.782L18.5001 16L26.0001 8.5L18.5001 1L17.2821 2.21799L22.7028 7.63862H0.992188V9.36138Z" fill={fill}  stroke={fill} strokeWidth="0.5" />
    </svg>
  );
};
